<template>
  <v-card>
    <v-tabs v-model="activeTab" background-color="transparent" grow>
      <v-tab v-for="tab in tabs" :key="tab.value" :href="`#${tab.value}`">
        {{ tab.label }}
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="tab in tabs" :key="tab.value" :value="tab.value">
        <v-card flat>
          <v-card-text class="py-10">
            <v-alert v-if="!isArenaSelected" type="info" class="mb-0">
              {{ tab.chooseArenaMsg }}
            </v-alert>
            <component v-else :is="tab.component" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Taxes from './taxes/index.vue'
import Suppliers from './suppliers/index.vue'
import PaymentMethods from './payment-methods/index.vue'
import CashRegisters from './cash-registers/index.vue'
import Company from './company/Company.vue'
import InvoiceSettings from './invoice-settings/index.vue'

export default {
  name: 'ShopSettings',
  components: {
    Taxes,
    Suppliers,
    PaymentMethods,
    CashRegisters,
    Company,
    InvoiceSettings,
  },
  data() {
    return {
      activeTab: 'company',
    }
  },
  computed: {
    isArenaSelected() {
      return !!this.$store.getters.arena
    },
    tabs() {
      const geti18nMsg = (entityName) =>
        this.$t(`entities.${entityName}.chooseArenaToDisplayTab`)
      return [
        {
          label: this.$t('entities.companies.entity'),
          chooseArenaMsg: geti18nMsg('companies'),
          value: 'company',
          component: Company,
        },
        {
          label: this.$t('entities.taxesV2.title'),
          chooseArenaMsg: geti18nMsg('taxesV2'),
          value: 'taxes',
          component: Taxes,
        },
        {
          label: this.$t('entities.suppliers.title'),
          chooseArenaMsg: geti18nMsg('suppliers'),
          value: 'suppliers',
          component: Suppliers,
        },
        {
          label: this.$t('entities.paymentMethods.title'),
          chooseArenaMsg: geti18nMsg('paymentMethods'),
          value: 'payment-methods',
          component: PaymentMethods,
        },
        {
          label: this.$t('entities.cashRegisters.title'),
          chooseArenaMsg: geti18nMsg('cashRegisters'),
          value: 'cash-registers',
          component: CashRegisters,
        },
        {
          label: this.$t('entities.invoiceSettings.title'),
          chooseArenaMsg: geti18nMsg('invoiceSettings'),
          value: 'invoice-settings',
          component: InvoiceSettings,
        },
      ]
    },
  },
}
</script>
